
import {defineComponent} from 'vue'
import GlobalEventBus, {EventsList} from "../../utils/GlobalEventBus";
import {get, set} from 'idb-keyval'

export default defineComponent({
  name: "ThemeSwitcher",

  data() {
    return {

      auto_switch_theme: {
        type: Boolean,
        default: false,
      }

    }
  },
  methods: {

    changeTheme(theme) {
      GlobalEventBus.emit(EventsList.ChangeTheme, theme)
    }

  },
  async mounted() {
    this.auto_switch_theme = (await get('xComponents'))?.auto_switch_theme ?? false
  },
  watch: {

    auto_switch_theme: {
      handler: async function (n) {
        set('xComponents', {...(await get('xComponents')), auto_switch_theme: this.auto_switch_theme});
        if (n)
          GlobalEventBus.emit(EventsList.ChangeTheme, 'auto')
      }
    }

  }
})
